
import 'slick-carousel';
const $ =require('jquery');
window.$ = $
$(function(){
   var next = $("#nextArrow");
   var prev = $("#prevArrow");
   var next_produit = $("#nextArrowProduit");
   var prev_produit = $("#prevArrowProduit");
   setTimeout(function(){
    $("#testslick").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: next,
        prevArrow: prev,
        responsive: [
            {
                breakpoint: 980, // tablet breakpoint
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480, // mobile breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $("#slick_accueil").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        nextArrow: false,
        prevArrow: false,
        dots: true,
    });
    $("#slick_produit").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: next_produit,
        prevArrow: prev_produit,
        responsive: [
            {
                breakpoint: 480, // mobile breakpoint
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $("#slick_produits_accueil").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        nextArrow: false,
        prevArrow: false,
        dots: true,
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
   },100)
})

